var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRelations = function SvgRelations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.143 2.857A2.854 2.854 0 0 0 14.388 5h-3.009A5.712 5.712 0 1 0 5 11.38v3.009a2.857 2.857 0 1 0 1.429 0V11.38a5.7 5.7 0 0 0 2.784-1.158l2.621 2.622a2.8 2.8 0 0 0-.405 1.442 2.857 2.857 0 1 0 2.857-2.857 2.8 2.8 0 0 0-1.442.405l-2.621-2.621a5.7 5.7 0 0 0 1.157-2.784h3.008a2.852 2.852 0 1 0 2.755-3.572m-10 14.286a1.428 1.428 0 1 1-2.857 0 1.428 1.428 0 0 1 2.857 0M5.715 10a4.286 4.286 0 1 1 0-8.571 4.286 4.286 0 0 1 0 8.571m10 4.286a1.429 1.429 0 1 1-2.858 0 1.429 1.429 0 0 1 2.858 0m1.428-7.143a1.428 1.428 0 1 1 0-2.857 1.428 1.428 0 0 1 0 2.857"
  })));
};
export default SvgRelations;